<template>
  <div class="home-page bg" v-if="page">
    <div class="nav-box bg">
      <div class="logo"><img src="../../assets/images/index-logo.png" /></div>
      <div :class="{ 'nav-container': true, bottom: typeList.length === 0 }">
        <!-- <div
          :class="{ 'nav-item': true, 'is-click': curTrainType === 'all' }"
          @click="handleChangeTab"
        >
          视多宝课堂
        </div> -->
        <div
          :class="{ 'nav-item': true, 'is-click': curTrainType === item.key }"
          v-for="(item, index) in navList"
          :key="index"
          @click="getCurTypeTrain(item)"
        >
          <!-- <el-popover
            ref="hoverPop"
            placement="top-start"
            width="630"
            :content="item.content"
            trigger="hover"
          >
            <span slot="reference"> {{ item.title }}</span>
          </el-popover> -->
          {{ item.title }}
        </div>
      </div>
      <div
        :class="{
          typeTrain: true,
          CjAndJx: curTrainType === 'rs',
          TyzAndTss: curTrainType === 'rsxs',
          RhAndLts: curTrainType === 'sgn',
        }"
        v-if="typeList.length > 0"
      >
        <el-checkbox-group
          class="train-checkbox"
          v-model="trainTypeList"
          @change="handleTrainTypeList"
          :min="1"
        >
          <el-checkbox
            v-for="(types, index) in typeList"
            :label="types.type"
            :key="index"
            border
            >{{ types.name }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
      <div :class="{ signout: true, bottom: typeList.length === 0 }">
        <el-dropdown>
          <el-button round>
            {{ name }}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              ><span class="wid100" @click="openUpdatePwdDialog"
                >修改密码</span
              ></el-dropdown-item
            >
            <el-dropdown-item
              ><span class="wid100" @click="aboutVisible = true"
                >关于</span
              ></el-dropdown-item
            >
            <el-dropdown-item
              ><span class="wid100" @click="handleLogout"
                >退出</span
              ></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="main-box">
      <div class="expire" v-if="expire">
        温馨提示：您的账户已经到期，请及时充值。
      </div>
      <div class="main-container intro" v-if="curTrainType === 'all'">
        <div
          class="main-intro-wrapper"
          v-for="(item, index) in homeIntroductions"
          :key="index"
          @click="handleOgpenDialog(item)"
        >
          <div class="main-intro__content">
            <img :src="item.bgImage" alt="img" />
          </div>
        </div>
      </div>
      <div class="home-train" v-if="['rs', 'rsxs'].includes(curTrainType)">
        <home-train :trainTypeList="trainTypeList"></home-train>
      </div>
      <div class="main-container intro" v-else>
        <div
          class="main-intro-wrapper"
          v-for="(item, index) in homeIntroductions"
          :key="index"
          @click="handleOpenDialog(item)"
        >
          <div class="main-intro__content">
            <img :src="item.bgImage" alt="img" />
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="intro-dialog"
      :title="introForm.title"
      :visible.sync="introDialog"
      v-if="introDialog"
      center
      width="40%"
    >
      <div v-if="introForm.content" class="center">
        <p v-for="(item, index) in introForm.content" :key="index">
          {{ item }}
        </p>
      </div>
      <div v-else class="padding40">
        <div
          v-for="(item, index) in introForm.typeList"
          :key="index"
          class="type-item"
        >
          <h4 class="typeTitle">{{ item.typeName }}</h4>
          <div>
            <p
              class="textIdent"
              v-for="(content, index) in item.contents"
              :key="index"
            >
              {{ content }}
            </p>
          </div>
          <div class="typeImg-wrapper">
            <img
              class="typeImg"
              v-for="(src, index) in item.imgList"
              :key="index"
              :src="src"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="introDialog = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改密码"
      :visible.sync="updatePwd"
      v-if="updatePwd"
      width="30%"
    >
      <el-form
        :model="pwdForm"
        :rules="loginFormjRules"
        ref="pwdForm"
        label-width="100px"
      >
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input
            type="password"
            v-model="pwdForm.oldPassword"
            placeholder="请输入旧密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            type="password"
            v-model="pwdForm.newPassword"
            placeholder="请输入新密码"
            @change="newpwdChange"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input
            type="password"
            v-model="pwdForm.confirmPassword"
            placeholder="请确认新密码"
            @change="confirmpwdChange"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleChange">确 定</el-button>
        <el-button @click="updatePwd = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="关于" :visible.sync="aboutVisible" width="50%">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="label" label="产品名称" width="180" />
        <el-table-column prop="value" label="视觉训练系统" />
      </el-table>
    </el-dialog>
  </div>
  <transition name="fade" mode="out-in" v-else>
    <router-view></router-view>
  </transition>
</template>

<script>
import { Vue, Component, Watch } from 'vue-property-decorator'
import { navList } from '@src/constant/nav'
import { homeIntroductions } from '@src/constant/home'
import homeTrain from '@src/components/homeTrain'
import { updatePwd } from '@api/login'
import loginFormjRules from '@utils/rules/loginFormRules'
import { validateForm } from '@utils'
import { encryption } from '@utils/crypto'

import { namespace } from 'vuex-class'
const moduleTrain = namespace('train')
const moduleUser = namespace('user')
import { MessageBox } from 'element-ui'
import { formatDate, calculateDaysDiff } from '@/utils/date'

@Component({
  components: { homeTrain },
})
export default class Home extends Vue {
  navList = navList
  page = true
  updatePwd = false
  pwdForm = {
    confirmPassword: '',
    newPassword: '',
    oldPassword: '',
  }
  typeList = []
  trainTypeList = []
  curTrainType = 'rs'

  homeIntroductions = homeIntroductions.slice(0, -1)
  introForm = {}
  introDialog = false

  aboutVisible = false
  tableData = [
    { label: '型号规格', value: 'v1.0' },
    { label: '注册人名称', value: '湖南铂欣科技有限公司' },
    { label: '注册证编号', value: '湘械注准20232210101' },
    { label: '生产许可证号', value: '湘药监械生产许20240030号' },
    {
      label: '注册人住所',
      value:
        '长沙高新开发区东方红街道青山路699号湖南省军民融合科技创新产业园1栋研发楼1609',
    },
    {
      label: '生产地址',
      value:
        '长沙高新开发区东方红街道青山路699号湖南省军民融合科技创新产业园1栋研发楼1609',
    },
    {
      label: '适用范围',
      value:
        '对儿童和青少年的弱视、斜视及对融合功能不足引起的视觉疲劳有治疗作用，可不同程度提高视力和建立、完善双眼视功能。',
    },
    { label: '生产日期', value: '2023年2月7日' },
    { label: '有效期', value: '5年' },
  ]

  @moduleTrain.Mutation SET_TRAIN_TYPE_INFO
  @moduleUser.Action Logout
  @moduleUser.Action FeLogout
  @moduleUser.Getter name
  @moduleUser.Getter openDay
  @moduleUser.Getter usedDay
  @moduleUser.Getter expireDate
  @moduleUser.Getter role

  created() {
    this.loginFormjRules = loginFormjRules
    if (this.$route.path === '/home') {
      this.page = true
    } else {
      this.page = false
    }
    this._getSdxTrainExpire()
    this.getCurTypeTrain(navList[0])
  }

  @Watch('$route')
  onRouteChanged(val) {
    if (val.path === '/home') {
      this.page = true
      this.curTrainType = 'all'
      this.typeList = []
    }
  }

  get expire() {
    return this.usedDay > this.openDay
  }

  handleChangeTab() {
    this.curTrainType = 'all'
    this.typeList = []
  }

  handleTrainTypeList(value) {
    console.log(value)
  }

  handleOgpenDialog(item) {
    this.introForm = { ...item }
    this.introDialog = true
  }

  async handleLogout() {
    await this.Logout()
    location.reload()
  }

  openUpdatePwdDialog() {
    this.updatePwd = true
    this.pwdForm = {
      confirmPassword: '',
      newPassword: '',
      oldPassword: '',
    }
  }

  newpwdChange(value) {
    console.log(value)
    if (this.pwdForm.newPassword === this.pwdForm.oldPassword) {
      this.$message.warning('新密码和旧密码不能相同')
      return false
    } else {
      return true
    }
  }

  handleOpenDialog(item) {
    this.introForm = { ...item }
    if (item.title === '微信指导') {
      this.SET_SHOW_TRAINER_WECHAT(true)
    } else {
      this.introDialog = true
    }
  }

  confirmpwdChange() {
    if (
      this.pwdForm.newPassword !== '' &&
      this.pwdForm.confirmPassword !== this.pwdForm.newPassword
    ) {
      this.$message.warning('确认密码和新密码输入不一致')
      return false
    } else {
      return true
    }
  }
  async handleChange() {
    const valid = await validateForm.call(this, 'pwdForm')
    valid && this.newpwdChange() && this.confirmpwdChange() && this.changePwd()
  }

  async changePwd() {
    const encryptOld = encryption({
      data: this.pwdForm,
      encryptArr: ['oldPassword'],
    })
    const encryptNew = encryption({
      data: this.pwdForm,
      encryptArr: ['newPassword'],
    })
    // console.log(encryptNew.newPassword, encryptOld.oldPassword)
    const res = await updatePwd({
      oldPassword: encryptOld.oldPassword,
      newPassword: encryptNew.newPassword,
    })
    if (res.code === 0) {
      this.updatePwd = false
      await this.FeLogout()
      location.reload()
    }
  }

  getCurTypeTrain(row) {
    this.typeList = []
    console.log(1)
    if (row.key === 'ksjc') {
      return window.open('https://exam.sgeye.com', 'exam')
    }
    this.curTrainType = row.key
    Object.assign(this.typeList, row.trainArray)
    this.trainTypeList =
      row.trainArray.length > 0
        ? row.trainArray.map(item => {
            return item.type
          })
        : []
  }
  handleRedirectTo(row) {
    this.SET_TRAIN_TYPE_INFO(row)
    this.$router.push({ path: row.path })
    this.page = false
  }

  _getSdxTrainExpire() {
    if (this.role !== 1 && this.role !== 2) {
      return
    }
    if (!this.expireDate) {
      return
    }
    const nowDate = formatDate(new Date(), 'yyyy-MM-dd')
    const diffDay = calculateDaysDiff(nowDate, this.expireDate)
    console.log(diffDay)
    if (diffDay > 15) {
      return
    }
    const name = this.role === 2 ? '客户经理' : '门店'
    const type = this.role === 2 ? '到店版' : '高级版'
    const firstRowMessage = `您的${type}训练账户将于${this.expireDate}到期,`
    const lastRowMessage = `为了不影响您的使用，请联系${name}续费。`
    const h = this.$createElement
    MessageBox.confirm(
      h('div', [h('p', firstRowMessage), h('p', lastRowMessage)]),
      '到期提醒',
      {
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: '我知道了',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        center: true,
        type: 'warning',
      }
    )
  }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
.train-checkbox {
  .el-checkbox {
    color: #fff;
  }
}

.center {
  padding: 0 80px;
}
.padding40 {
  padding: 0 40px;
  .type-item {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px dotted #ccc;
  }
  .typeTitle {
    margin: 0;
    font-size: 16px;
    line-height: 20px;
  }
  .textIdent {
    text-indent: 2em;
  }
  .typeImg-wrapper {
    display: flex;
    justify-content: space-around;
    .typeImg {
      width: 120px;
      height: 100px;
    }
  }
}
</style>
<style lang="scss">
.intro-dialog {
  .el-dialog__title {
    color: #585ad6;
  }
}
</style>
